import React from "react";
import styled from "styled-components";
import {TitleBar} from "./TitleBar";
import RankingTable from "./RankingTable";

const Container = styled.div`
    display: flex;
    flex-direction: column;
    background-color: white;
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: 252px;
`;


const Footer = styled.div`
    display: flex;
    flex-grow: 0;
    align-items: center;
    background-color: #f0ece9;
    border-bottom: solid 1px rgba(159, 167, 178, 0.32);
    border-left: solid 1px rgba(159, 167, 178, 0.32);
    border-right: solid 1px rgba(159, 167, 178, 0.32);
    padding-left: 31px;
    height: 32px;
    font-size: 12px;
`;

const TotalAuthors = styled.div`
    flex-grow: 1;
    font-weight: bold;
`;

const UnrankedAuthors = styled.div`
    font-weight: bold;
    padding-right: 22px;
`;

export const Rankings = ({portfolioAuthor, selectedAuthorId, signedOnUserId, portfolioAuthorActions, rankingsView, sort, onRowClick, scrollToAuthor}) => {
    const {rankings: {myTeam, allContributors}, performanceSettings, totalRanked, kpi, benchmarkSource, defaultBenchmark, actionToGetRanked} = portfolioAuthor;

    let rankingList;
    switch (rankingsView) {
        case "my-team":
            rankingList = myTeam;
            break;
        case "all-contributors":
            rankingList = allContributors;
            break;
    }

    if (!rankingList) rankingList = [];

    const totalRankedText = !totalRanked ? "" : `${totalRanked} total authors`;

    const unrankedAuthors = rankingList.filter(r => !r.rank).length;
    const pluralise = unrankedAuthors !== 1 ? "s" : "";
    const unrankedCountText = `${unrankedAuthors} author${pluralise} unranked`;
    const footer = <Footer className="t-footer">
        <TotalAuthors className="t-total-authors">{totalRankedText}</TotalAuthors>
        <UnrankedAuthors className="t-unranked-count">{unrankedCountText}</UnrankedAuthors>
    </Footer>;

    return <Container className="t-rankings">
        <TitleBar portfolioAuthorActions={portfolioAuthorActions}
                  rankingsView={rankingsView}/>

        <RankingTable rankingList={rankingList}
                      selectedAuthorId={selectedAuthorId}
                      signedOnUserId={signedOnUserId}
                      sort={sort}
                      sortRankingsFn={portfolioAuthorActions.sortRankingsBy}
                      currency={performanceSettings ? performanceSettings.currency : null}
                      shareBased={performanceSettings ? performanceSettings.shareBased : true}
                      kpi={kpi}
                      actionToGetRanked={actionToGetRanked}
                      benchmarkSource={benchmarkSource}
                      defaultBenchmark={defaultBenchmark}
                      onRowClick={onRowClick}
                      scrollToAuthor={scrollToAuthor}
        />

        {totalRankedText ? footer : null}
    </Container>;
};